import { Box, Card, CardContent } from '@mui/material';
import { ReactNode } from 'react';

const CustomCard = ({
  children,
  sx,
  variant = 'flat',
  onClick,
  ...props
}: {
  children: ReactNode;
  onClick?: () => void;
  sx?: object;
  variant?: 'flat' | 'elevated' | 'outlined' | 'gradient';
}) => {

  const getCardStyle = () => {
    switch (variant) {
      case 'elevated':
        return {
          ...styles.card,
          ...(onClick ? styles.cardHover : {}),
        };
      case 'outlined':
        return styles.cardOutlined;
      case 'gradient':
        return {
          ...styles.cardGradient,
          ...(onClick ? styles.cardHover : {}),
        };
      case 'flat':
      default:
        return styles.cardFlat;
    }
  };

  return (
    <Box position="relative">
      <Card
        sx={{
          ...getCardStyle(),
          ...sx,
          ...(sx && (sx as any).boxShadow === 'none !important' ? {
            '&.MuiPaper-root': {
              '--Paper-shadow': 'none !important',
              '--Paper-overlay': 'none !important',
            }
          } : {})
        }}
        {...props}
      >
        <CardContent
          onClick={onClick}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            '&:last-child': { pb: { xs: 2, sm: 2.5, md: 3 } },
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CustomCard;

const styles = {
  card: {
    borderRadius: { xs: 2, sm: 2.5, md: 3 },
    backgroundColor: 'background.white',
    height: '100%',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
  },
  cardFlat: {
    borderRadius: { xs: 2, sm: 2.5, md: 3 },
    bgcolor: 'background.white',
  },
  cardOutlined: {
    borderRadius: { xs: 2, sm: 2.5, md: 3 },
    bgcolor: 'background.white',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  cardGradient: {
    borderRadius: { xs: 2, sm: 2.5, md: 3 },
    background: (theme: any) => theme.palette.background.cardGradient,
    height: '100%',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
  },
  cardHover: {
    cursor: 'pointer',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: (theme: any) => theme.palette.background.primaryGradient,
      opacity: 0,
      transition: 'opacity 0.3s ease',
      zIndex: 1,
    },
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      borderColor: 'border.medium',
      '&::before': {
        opacity: 1,
      },
    },
    '&:active': {
      transform: 'translateY(-2px)',
    },
  },
};
